(function() {
  "use strict";

  angular.module("sempraWebapp").constant("hrTranslations", {
    MESSAGE:"Poruka",
    ERROR_TITLE:"Greška",
    ERROR_MESSAGE:"Došlo je do greške tokom izvršavanja operacije.",
    ERROR_LOGIN:"Greška prilikom prijavljivanja. Email adresa je nepoznata ili se lozika ne podudara. Molimo Vas pokušajte ponovo.",
    ERROR_LOGIN_ROLE:"Uloga za trenutnu aplikaciju nije važeća",
    OK:"OK",
    CANCEL:"Otkaži",
    YES:"Da",
    NO:"Ne",
    UNLIMITED:"Neograničeno",
    FROM:"Od",
    TO:"Do",
    DELETE:"Obriši",
    SIGN_OUT:"Odjavi se",
    NAME:"Ime",
    DATE:"Datum",
    PIECES:"komada",
    HOURS:"Sati",
    DAYS:"Dani",
    MONTH:"Mjesec",
    MONTHS:"Mjeseci",
    YEAR:"Godina",
    BOX:"Box",
    SEARCH:"Traži",
    ALL_USERS:"Svi korisnici",
    ARE_YOU_SURE:"Sigurni ste?",
    BACK:"Nazad",
    AMOUNT:"Opis",
    DESCRIPTION:"Opis",
    FORGOT_PASSWORD_ERROR_MSG:"Da li ste sigurni",
    REQUIRED_FIELD:"Polje je obavezno",
    LOGOUT_TITLE:"Da li ste sigurni da se želite odjaviti",
    LOGOUT_MSG:"Sve nespremljene izmjene bit će obrisane",
    ACTIVATION_ACCOUNT:"Uspješno ste aktivirali nalog, nastavite ka ekranu za prijavu",
    UNKNOWN_ERRROR_NOTIFICATION:"Nastavite",
    CONTINUE:"Dogodila se nepoznata greška",
    DATA_NOT_AVAILABLE:"Podaci nisu pronađeni",
    SELECT:"Izaberi",
    SELECT_CURRENCY:"Izaberi valutu",
    UPLOAD:"Pošalji",
    PHONE:"Telefon",
    WEBSITE:"Internet stranica",
    WORKING_HOURS:"Radno vrijeme",
    INSERT:"Unesi",
    TEXT:"Tekst",
    CREATED:"Kreirana",
    VALID_UNTIL:"Traje do",
    SAVE:"Spremi",
    TOKENS:"Žetona",
    DELETE_COMPANY_HISTORY:"Obrisati istoriju kompanije?",
    DELETE_COMPANY_HISTORY_MESSAGE:"UPOZORENJE: Nakon pritiska na ovaj gumb, sve transakcije Vaše autopraonice bit će trajno izbrisane! Ovi podaci se ne mogu vratiti nakon brisanja.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Jeste li sigurni da želite trajno izbrisati sve podatke o transakcijama?",
    HISTORY_SUCCESSFULY_DELETED:"Istorija uspešno obrisana",
    HELP:"Pomoć",
    VALUE:"Vrijednost",
    ACTIVATING_ACCOUNT_ERROR:"Došlo je do greške prilikom aktivacije vašeg R2W računa.Molimo pokušajte ponovo i ako problem i dalje postoji kontaktirajte support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Dobrodošli u Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Dobrodošli na R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Molimo upišite i ponovite svoju lozinku da bi aktivirali svoj R2W račun. Bit ćete automatski prijavljeni na sistem nakon uspješne verifikacije lozinke",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Svoje podatke možete mijenjati kasnije u aplikaciji",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Kärcher autopraonica",
    RESET_PASSWORD_WELCOME_MSG:"R2W autopraonica",
    RESET_PASSWORD_WELCOME_MSG_2:"Molimo unesite svoju novu lozinku i potvrdite je kako biste resetirali staru lozinku. Nakon uspješno promenjene lozinke bit ćete automatski prijavljeni u aplikaciju.",
    RESET_PASSWORD_WELCOME_MSG_3:"Vaše korisničke postavke možete kasnije promijeniti u aplikaciji.",
    ENTER_NEW_PASSWORD:"Unesite novu lozinku",
    REPEAT_NEW_PASSWORD:"Ponovite lozinku",
    PASSWORD_MIN_LENGTH:"Lozinka mora imati barem 8 znakova",
    PASSWORD_MAX_LENGHT:"Lozinka ne smije imati više od 32 znakova",
    PASSWORD_PATTERN:"Lozinka mora sadržavati barem jedno veliko i jedno malo slovo",
    PASSWORD_MATCH:"Lozinke nisu identične",
    ACTIVATE:"Aktiviraj",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Uspješno ste poslali zahtjev. Provjerite poruku u e-pošti za potvrdu",
    VALIDATION_REQUIRED:"Obavezno polje",
    VALIDATION_EMAIL:"Neispravna email adresa",
    VALIDATION_INTEGER_NUMBER:"Vrijednost mora biti cijeli broj",
    VALIDATION_HOURS_VALUE:"Vrijednost mora biti između 0-23",
    VALIDATION_MINUTES_VALUE:"Vrijednost mora biti između 0-59",
    VALIDATION_NOT_A_DATE:"Unesena vrijednost nije datum",
    VALIDATION_FROM:"Datum veći od krajnjeg datuma",
    VALIDATION_TO:"Datum manji od početnog datuma",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Taj podatak već postoji u bazi podataka",
    PASSWORD_VALIDATION_PATTERN_NEW:"Lozinka mora sadržavati barem jedno veliko i malo slovo i jedan broj. Prazna polja također nisu dozvoljena.",
    VALIDATION_PERCENT_VALUE:"Vrijednost mora biti između 1-999",
    NUMBERS_ONLY_100:"Broj do 100",
    NUMBERS_ONLY_1000:"Broj do 1000",
    POSITIVE_NUMBERS_ONLY:"Samo pozitivan broj",
    GRID_PAGER_PAGE:"Stranica",
    GRID_PAGER_ROWS_PER_PAGE:"Redova po stranici",
    GRID_PAGER_PAGE_OF:"od",
    BREAD_CRUMBS_HOME:"Početna",
    BREAD_CRUMBS_DASHBOARD_TECH:"Pregled praonica",
    BREAD_CRUMBS_DETAILS:"Detalji",
    BREAD_CRUMBS_SETTINGS:"Podešavanja",
    BREAD_CRUMBS_WORKING_HOURS:"Radno vrijeme",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Ukupno novca po danima",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Prosječno novca po satima",
    BREAD_CRUMBS_NEW_USER_GROUP:"Kreiranje korisničke grupe",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Izmjena korisničke grupe",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Kreiranje šablona kampanje",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Izmjena šablona kampanje",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Kreiranje kampanje",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Izmjena kampanje",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Pregled financija za razdoblje",
    LOGIN:"Prijava",
    EMAIL:"E-mail",
    PASSWORD:"Lozinka",
    LANGUAGE:"Jezik",
    FORGOT_PASSWORD:"Zaboravljena lozinka?",
    SUBMIT:"Potvrdi",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Broj tekućih alarma:",
    HEADER_VIEW_ALL_ALARMS:"Svi alarmi...",
    HEADER_MY_ACCOUNT:"Moj račun",
    HEADER_ACCOUNT_MANAGEMENT:"Upravljanje računima",
    ACCOUNT_ALREADY_EXIST:"Email adresa već postoji",
    NEWSLETTER_CONFIRMATION:"Pošaljite obavijest e-poštom za stanje alarma",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Dnevni pregled financija",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Pregled praonica",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Praonice",
    ASIDE_MENU_ALARMS:"Alarmi",
    ASIDE_MENU_FACILITIES:"Praonice",
    ASIDE_MENU_REPORTS:"Izvještaji",
    ASIDE_MENU_REPORT:"Odabrano izvješće",
    ASIDE_MENU_LOYALTY:"Kampanje",
    ASIDE_MENU_USER_GROUPS:"Grupe korisnika",
    ASIDE_MENU_PERIODIC_SUMMARY:"Pregled po razdoblju",
    ASIDE_MENU_MANAGING_TOKENS:"Upravljanje žetonima",
    ASIDE_MENU_NEWS:"Vijesti",
    DAILY_FINANCES_TOTAL_MONEY:"Ukupno novca",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Ukupno novca za sve praonice",
    DAILY_FINANCES_TOTAL_COINS:"Ukupno iskorištenih metalnih žetona",
    DAILY_FINANCES_DOWNLOAD_CSV:"Preuzmi CSV",
    DAILY_FINANCES_ONLINE:"Online",
    DAILY_FINANCES_OFFLINE:"Gotovina",
    DAILY_FINANCES_CHANGER:"Gotovina u mjenjaču",
    DAILY_FINANCES_COINS:"Žetoni",
    REPORTS_FILTER:"Filter",
    REPORTS_TYPE_OF_REPORT:"Tip izvještaja",
    REPORTS_CHOOSE_FACILITY:"Odabir praonice",
    REPORTS_PERIOD_1:"Period 1 - ",
    REPORTS_PERIOD_2:"Period 2 - ",
    MONEY_BY_DATE_REPORT:"Ukupno novca po danu",
    R2W_BY_DATE_REPORT:"Ukupno online plaćanja po danu",
    COINS_BY_DATE_REPORT:"Ukupno žetona po danu",
    AVG_MONEY_BY_HOUR_REPORT:"Prosječno novca po satu",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Prosječno novca po danu",
    AVG_MONEY_BY_BOX_REPORT:"Potrošnja po box-u",
    COMPARE_PERIODS_REPORT:"Usporedni prikaz po praonici",
    TOTAL_USERS_BY_GROUP:"Ukupno korisnika po danu",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"korisnika",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"posjeta",
    VISITS_COUNT_REPORT:"Broj korisnika po dolascima",
    LOYALTY_PER_DAY_REPORT:"Izdanih žetona po danu",
    LOYALTY_PER_PAYMENT_METHOD:"Lojalnost po načinu plaćanja",
    VISITS:"Posjete",
    VISIT:"Posjeta",
    TOTAL_SPENT_MONEY:"Ukupno potrošenog novca",
    MONEY:"Novac",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Ukupno potrošenog novca za razdoblje",
    DOWNLOAD_CSV:"Preuzmi CSV",
    TOTAL_SPENT_COINS:"Ukupno potrošenih žetona",
    TOTAL_USERS:"Ukupno korisnika",
    TOTAL_CREDIT_GIVEN:"Ukupno potrošenih lokalnih virtualnih žetona",
    EUROKEY_BY_DATE_REPORT:"Ukupna plaćanja euro ključa",
    TOTAL_SPENT_EUROKEY:"Ukupno potrošeno",
    SELECT_TYPE_OF_REPORT:"Morate odabrati vrstu izvješća :)",
    NUMBER_OF_VISITS_TITLE:"Broj posjeta",
    NUMBER_OF_USERS_TITLE:"Broj korisnika",
    PIECES_TITLE:"Komadi",
    TOTAL_VISITS:"Ukupno posjeta",
    TOKENS_TITLE:"žetona",
    SEARCH_USERS_NO_RESULTS:"Nema korisnika za zadani kriterij pretrage",
    SEARCH_USERS:"Pretraga korisnika",
    SEARCH_TELEPHONES:"Pretraga po broju mob. telefona",
    ADD_USER_TO_GROUP:"Dodaj korisnika u grupu",
    REMOVE_USER_FROM_GROUP:"Obriši korisnika iz grupe",
    USER_GROUP_NAME_REQUIRED:"Ime grupe korisnika je obavezno polje.",
    USER_GROUP_NAME:"Ime grupe korisnika",
    USER_GROUPS_OVERVIEW:"Pregled grupa korisnika",
    USER_COUNT:"Broj korisnika",
    NEW_USER_GROUP:"Kreiraj novu grupu korisnika",
    DELETE_USER_GROUP:"Obriši grupu korisnika",
    UPDATE_USER_GROUP:"Izmjeni grupu korisnika",
    DELETE_USER_GROUP_ERROR:"Došlo je do greške prilikom brisanja odabrane korisničke grupe. Molimo Vas pokušajte ponovo ili kontaktirajte tehničku podršku...",
    CONFIRM_DELETE_USER_GROUP:"Da li ste sigurni da želite obrisati odabranu grupu korisnika?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Akcije kojima je grupa bila dodijeljena prestat će vrijediti za korisnike obrisane grupe.",
    GROUP_NAME_MAX_LENGTH:"Ime grupe mora biti manje od 255 karaktera",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Korisnik je već u ovoj grupi",
    MISSING_USER:"Nepoznat korisnik",
    USER_NOT_ON_LIST:"Korisnik nije u aktivnoj listi. Proverite da li je email ispravan i pokušajte ponovo.",
    UPLOAD_USER_GROUP:"Uvezi grupe iz *.csv-a",
    UKNOWN_USERS:"Lista nepoznatih korisnika",
    CAMPAIGN_TEMPLATE_RULE:"Pravilo kampanje",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Došlo je do pogreške prilikom brisanja odabranog šablona kampanje. Molimo Vas pokušajte ponovo ili kontaktirajte tehničku podršku...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Da li ste sigurni da želite obrisati odabrani šablon kampanje?",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:" Jeste li sigurni da želite izbrisati odabrani predložak kampanje",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Pregled predloška kampanja",
    DELETE_CAMPAIGN_TEMPLATE:"Obriši predložak kampanje",
    UPDATE_CAMPAIGN_TEMPLATE:"Izmjeni predložak kampanje",
    CREATE_CAMPAIGN_TEMPLATE:"Kreiraj novi predložak kampanje",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Ime predloška kampanje je obavezno polje.",
    CAMPAIGN_TEMPLATE_NAME:"Ime predloška kampanje",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Obavezno polje",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"pokloni %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"dodatnog vremena",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Prvo odaberite vrstu uređaja. Perilicu ili mali stroj.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Obriši pravilo",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Od",
    CAMPAIGN_TEMPLATE_RULE_TO:"do",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"sati",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minuta",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Novo pravilo po broju dolazaka",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Novo pravilo po količini potrošenih žetona",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Novo pravilo po danima u tjednu",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Dodaj novo pravilo",
    CAMPAIGN_TEMPLATE_RULE_1:"Svakih",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Svakih",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"žetona za manje od",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"dolazaka za manje od",
    CAMPAIGN_TEMPLATE_RULE_3:"dana, pokloni",
    CAMPAIGN_TEMPLATE_RULE_4:"žetona ",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Lista pravila je prazna.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Nije moguće unijeti prošlo vrijeme ",
    DELETE_CAMPAIGN_ERROR:"Došlo je do greške prilikom brisanja odabrane kampanje. Molimo Vas pokušajte ponovo ili kontaktirajte tehničku podršku...",
    CONFIRM_DELETE_CAMPAIGN:"Da li ste sigurni da želite obrisati odabranu kampanju?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W nije odgovoran za korisničko iskustvo uzrokovano ovom radnjom.",
    CAMPAIGNS_OVERVIEW:"Pregled kampanja",
    DELETE_CAMPAIGN:"Obriši kampanju",
    UPDATE_CAMPAIGN:"Izmjeni kampanju",
    CREATE_CAMPAIGN:"Kreiraj novu kampanju",
    CAMPAIGN_ACTIVE:"Aktivna",
    CAMPAIGN_TEMPLATE:"predložak",
    CAMPAIGN_GROUPS:"Grupe",
    CAMPAIGN_ALL_USERS:"Svi korisnici",
    CAMPAIGN_NAME:"Ime kampanje",
    CAMPAIGN_NAME_REQUIRED:"Ime kampanje je obavezno polje",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Korisnici blizu limita bonusa po danu",
    MESSAGE_TO_USERS:"Poruka pronađenim korisnicima",
    SEND_MESSAGE:"Pošalji poruku",
    THRESHOLD:"Limit",
    TYPE:"Tip",
    TOTAL_MONEY_SPENT:"Ukupno novca potrošenog u kampanji",
    NUMBER_OF_VISITS:"Ukupno posjeta u kampanji",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Poruka mora imati barem 10 znakova",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Poruka nesmije imati više od 350 znakova ",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Tekst poruke je obavezan",
    TECHNOLOGY:"Tehnologija",
    TAP_WATER:"Gradska voda",
    REVERSE_OSMOSIS:"Reverzna osmoza",
    SOFTENED_WATER:"Omekšana voda",
    DOSER:"Dozer",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Posljednja sinkronizacija",
    NO_OF_CURRENT_ALARMS:"Vaš broj tekućih alarma",
    NO_OF_CURRENT_WARNINGS:"Broj tekućih upozorenja",
    WEATHER:"Vrijeme",
    BOXES_WORK_HOURS_COUNTERS:"Brojači sati rada bokseva",
    BOX_TOTAL_HOURS:"Ukupno rada",
    BOX_SERVICE_HOURS:"Ukupno rada (servis)",
    BOX_COUNTER_HOURS:"Sati",
    ALARMS_AND_WARNINGS:"Alarmi i upozorenja",
    FILTER_AND_BOILER:"Filter i bojler",
    FILTER_TOTAL_DAYS:"Dani rada filtera",
    BOILER_TOTAL_DAYS:"Dani rada bojlera",
    DAYS_UNIT:"dana",
    SOFTENER:"Omekšivač",
    MANUAL_COLD_DRAIN:"Ručni zimski odvod",
    EL_COLD:"El. zimski",
    DRAIN:"odvod",
    TAP:"slavina",
    WASTE:"Otpad",
    OSMOSIS:"osmoza",
    DEMI_WATER:"Demi voda",
    EL_RINSE:"El. m. ispiranja",
    BOILER:"Bojler",
    EL_WAX:"El. m. voska",
    FLOOR_HEATING:"Podno grejanje",
    DOSER_TANK:"Kadica dozatora",
    EL_WASH:"El. m. pranja",
    DETERGENT:"Prašak",
    VIBRATOR:"Vibrator",
    UPDATE_FACILITY_SETTINGS:"Ažuriranje postavki praonice",
    GENERAL_SETTINGS:"Opće postavke",
    LIGHTS:"Svjetlo",
    GROUPS:"Grupe",
    ANTI_FREEZE:"Anti smrzavanje",
    AUTO:"Auto",
    MANUAL:"Ručno",
    ON:"Uključeno",
    OFF:"Isključeno",
    TEMPERATURE:"Temperatura",
    UPDATE_DEVICE:"Postavi postavke praonice",
    BOX_CLEAN_HOURS:"Brojač sati rada (čišćenje)",
    GROUP_COUNTERS:"Brojači grupa",
    RESET:"Reset",
    CASH_COUNT:"Brojač kovanica",
    COINS_COUNT:"Brojač žetona ",
    EUROKEY_COUNT:"Brojač Eurokey",
    DOSER_WORK:"Vrijeme rada dozera (sec.)",
    DOSER_PAUSE:"Vrijeme pauze dozera (sec.)",
    DELAY_BFV:"BFV kašnjenje (ms)",
    DELAY_6M1:"6M1 kašnjenje (ms)",
    DELAY_LPS:"LPS kašnjenje (ms)",
    RESET_CASH_COUNT_ALL:"Reset svih brojača kovanica",
    RESET_COINS_COUNT_ALL:"Reset svih brojača žetona ",
    RESET_EUROKEY_COUNT_ALL:"Reset svih brojača Eurokey-a",
    FACILITY_DETAILS:"Detalji praonice",
    FACILITY_NAME:"Ime praonice",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Uspješno ste poslali sliku",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Uspješno ste promijenili podatke",
    CONNECTED:"Povezan",
    DISCONNECTED:"Nepovezan",
    OFFLINE:"Isključen",
    MESSAGES_FILTER:"Filter poruka",
    FACILITY:"Praonica",
    APPLY:"Primjeni",
    TIME:"Vrijeme",
    LOCATION:"Lokacija",
    ACKNOWLEDGED:"Priznata",
    FILTERED_MESSAGES:"Filtrirane poruke",
    ACK:"Primijćena",
    NOT_ACK:"Ne primijećena",
    ALL:"Svi",
    ALL_FACILITIES:"Sve praonice",
    ENTER_DATE_PLACEHOLDER:"Unesite datum",
    OP_NESTANAK_NAPONA:"Nestanak napona - 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Pumpa greška MZS",
    OP_UPR_NAPON_24VAC_GRE:"Upravljački napon 24VAC error -5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Zaštita na suho spremnik pitke vode",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Pumpa pitke vode greška motorna zaštitna sklopka",
    OP_MIN_NIVO_OMEKS_VODE:"Zaštita na suho spremnik omekšane vode",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Pumpa omekšane vode greška motorske zaštitne sklopke",
    OP_MIN_NIVO_DEMIN_VODE:"Zaštita na suho spremnik demilizirane vode",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Pumpa demilizirane vode greška motorske zaštitne sklopke",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Pumpa reverzna osmoza greška motorske zaštitne sklopke",
    OP_BOJLER_GRESKA_MZS:"Bojler greška",
    OP_CRPKA_PRASKA_GRE_MZS:"Pumpa praška greška motorne zaštitne sklopke",
    OP_DOZATOR_PRASKA_GRE_MZS:"Dozator praška greška",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Vibrator raspršuje greška",
    OP_MIN_PRASAK_TON_ALARM:"Minimalni nivo spremnik praška",
    OP_USIS_KOV_TURBINA_GRESKA:"Usis kovanica turbina greška motorne zaštitne sklopke",
    OP_FILTER_VODE_ZACEPLJEN:"Filter vode začepljen",
    OP_VISKTL_RESET_SATI_RADA:"Visokotlačna pumpa servis",
    OPW_VISKTL_RESET_SATI_RADA:"Visokotlačna pumpa servis",
    OP_FILTER_DANI_RADA:"Filter servis",
    OP_BOJLER_DANI_RADA:"Bojler servis",
    OPW_ALARM_VISOKOTL_PUMPA:"Alarm visokotlačne pumpe",
    OPW_ALARM_FILTER_SERVIS:"Filter servis alarm",
    OPW_ALARM_BOJLER_SERVIS:"Bojler servis alarm",
    HAS_MEMBERS:"Izabrana grupa ima članove i ne može biti uklonjena. Morate prvo ukloniti članove.",
    PERIODIC_SUMMARY_FOR:"PERIODIČAN SUMARNI IZVJEŠTAJ ZA",
    PERIODIC_SUMMARY_REPORTS:"Periodičnii sumarni izvještaji",
    DATE_RANGE:"Vremenski period",
    FINANCIAL_REPORT:"Financijski izvještaj",
    GROSS_INCOME:"Ukupan prihod",
    GROSS_INCOME_SUM:"Suma ukupnog prihoda",
    COMMISSION_FEE:"Provizije",
    NET_INCOME:"Neto prihod (za naplatu)",
    COMMISSION_FEE_DETAILS:"Uključuju bankovne / PayPal provizije na transakcije ili SMS servis provizije.",
    LOYALTY_CREDITS_REPORT:"Lokalni žetoni",
    LOYALTY_GIVEN:"Poklonjeni lokalni žetoni",
    LOYALTY_USED:"Iskorišteni lokalni žetoni",
    LOYALTY_SOLD:"Prodati lokalni žetoni",
    LOYALTY_TOTAL:"Total",
    LOYALTY_CURRENT_MONTH:"Tekući mjesec",
    SOMETHING_WENT_WRONG:"Uuuuuuuuuuups, došlo je do greške :-(",
    MISSING_PAGE:"Oprostite, nismo u mogućnosti pronaći traženu stranicu",
    TRY_AGAIN:"Pokušajte ponovo",
    DEFAULT_ERROR_NAME:"Došlo je do nepoznate greška",
    DEFAULT_ERROR_DESCRIPTION:"Molimo pokušajte ponovo, ako problem i dalje postoji kontaktirajte ovlaštenu osobu",
    MY_ACCOUNT_DETAILS:"Detalji korisničkog računa",
    SAVE_CHANGES:"Spremi promjene",
    USERNAME:"Korisničko ime",
    FIRST_NAME:"Ime",
    LAST_NAME:"Prezime",
    USER_ROLE:"Korisnička grupa",
    OLD_PASSWORD:"Stara šifra",
    NEW_PASSWORD:"Nova šifra",
    OLD_PASSWORD_REQUIRED:"Stara šifra polje je obavezno",
    NEW_PASSWORD_REQUIRED:"Nova šifra polje je obavezno",
    NEW_PASSWORD_REPEAT:"Ponoviti novu šifru polje je obavezno",
    NEW_PASSWORD_NOT_MATCH:"Stara i nova šifra nisu identične",
    PASSWORD_DIFFERENT_VALIDATION:"Nova lozinka mora biti drugačija od stare",
    PASSWORD_MIN_CHAR:"Vaša lozinka mora imati barem 8 znakova",
    PASSWORD_MAX_CHAR:"Vaša lozinka mora imati do 32 znaka",
    PASSWORD_PATTERN_VALIDATION:"Lozinka mora sadržavati barem jedan broj, jedno malo i jedno veliko slovo",
    ACCOUNT_MANAGEMENT:"Upravljanje Korisnicima",
    NOT_ACTIVE:"Neaktivan",
    ASSIGN_ROLE:"Korisnička grupa",
    UPDATE:"Ažuriraj",
    ADD_NEW_ACCOUNT:"Dodavanje novog korisnika",
    EMAIL_REQUIRED:"E-mail adresa je obavezna",
    EMAIL_NOT_VALID:"E-mail adresa nije validna",
    ADD_NEW_USER_TEXT:"E-mail sa aktivacijskim linkom će biti poslan na upisanu adresu",
    UPDATE_USER_NOTIFICATION:"Uspješno ste ažurirali podatke",
    CHANGED_PASSWORD_NOTIFICATION:"Uspješno ste promijenili lozinku",
    UPDATE_USER_GROUP_NOTIFICATION:"Uspješno ste promijenili ime grupe",
    CREATE_USER_GROUP_NOTIFICATION:"Uspješno ste kreirali grupu",
    DETELE_USER_GROUP_NOTIFICATION:"Uspješno ste obrisali grupu",
    EMPTY_GROUP_LIST_MSG:"Nema kreiranih grupa. Za početak, napravite jednu",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Uspješno ste obrisali korisnika iz grupe",
    ADD_USER_TO_GROUP_NOTIFICATION:"Uspješno ste dodali korisnika u grupu",
    ADD_USER_NOTIFICATION:"Uspješno ste dodali novog korisnika",
    DELETE_USER_NOTIFICATION:"Uspješno ste obrisali korisnika",
    RESEND_USER_VERIFICATION_EMAIL:"Uspješno ste ponovo poslali verifikacijski email.",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Da bi ste kreirali grupu korisnika, molimo Vas unesite naziv grupe.",
    DELETE_USER:"Brisanje korisnika",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Da li ste sigurni da želite obrisati korisnika iz grupe?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Poštovani, ukoliko nas posjetite tokom akcije ovog mjeseca dobit ćete dodatni bonus na vaš račun.",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Pravilo kampanje po broju dolazaka",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Pravilo kampanje po potrošenim žetonima",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Pravilo kampanje po danima u tjednu",
    REMOVE_CAMPAIGN_RULE_TITLE:"Brisanje pravila kampanje",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Da li ste sigurni da želite obrisati pravilo kampanje?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Uspješno ste spremili novo pravilo kampanje",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Uspješno ste aktivirali kampanju",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Nema kreiranih kampanja. Za početak, napravite jednu",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Uspješno ste poslali poruku",
    COMPANY_ACCOUNTS:"Računi tvrtki",
    BUSSINESS_INVOICES_LIST:"Moji B2B računi",
    LOCALE_TOKEN:"Lokalni žeton",
    R2W:"Globalni žeton",
    START_MONTH:"Početni mjesec",
    END_MONTH:"Krajnji mjesec",
    TOKEN_TYPE:"Tip žetona",
    TOKEN_NUMBER:"Broj žetona",
    NOTHING_TO_DISPLAY:"* Ništa za prikaz",
    CREATE_INVOICE:"Nova faktura",
    INVOICE:"Faktura",
    INVOICES:"Fakture",
    EDIT_INVOICE:"Promjeni fakturu",
    UPDATE_INVOICE_NOTIFICATION:"Uspješno ste promijenili status fakture u 'u izvršenju'",
    CURRENT_CHARGES:"Zaduženje za tekuće razdoblje",
    PAYMENTS_ON_HOLD:"Poslani računi",
    FOR_INVOICING:"Nije fakturirano",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Pokušavate poništiti fakturu",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Da li ste sigurni da želite poništiti fakturu ???",
    INVOICING_NOTIFICATION_HEADER:"Pokušavate poslati fakturu",
    INVOICING_NOTIFICATION_TEXT:"Da li ste sigurni da želite poslati fakturu?",
    SENT_INVOICE_NOTIFICATION:"Račun je uspješno poslan ",
    CANCELED_INVOICE_NOTIFICATION:"Uspješno ste poništili račun ",
    INVOICE_DESCRIPTION_TEXT:"Faktura za mjesec ",
    INVOICE_STATE:"Status fakture",
    INVOICE_NUMBER:"Broj fakture",
    INVOICE_TOTAL:"Ukupno",
    SELECT_YEAR:"Izaberi godinu",
    DOWNLOAD:"Skini PDF",
    INVOICE_NUMBER_HEADER:"Namjeravate poslati fakturu sa brojem ",
    INVOICE_PAYMENT_CONFIRMATION:"Namjeravate potvrditi plaćanje fakture sa brojem ",
    INSERT_INVOICE_NUMBER:"Unesi broj fakture",
    INVOICED_WARNING:"Email nije poslan. Molim Vas pričekajte ...",
    SEND_INVOICE:"Pošalji",
    INVOICE_ALL:"Sve",
    INVOICE_FROM_R2W:"Od R2W",
    INVOICE_TO_R2W:"Za R2W",
    PAYMENT_REQUEST:"Zahtjev za plaćanje",
    PAYMENT_REQUEST_STATE:"Stanje zahtjeva za plaćanje",
    PAYMENT_REQUEST_NUMBER:"Broj zahtjeva za plaćanje",
    FOR_PAYMENT_REQUEST:"Za zahtjev za plaćanjem",
    PAYMENT_REQUEST_ON_HOLD:"Zahtjev za plaćanjem u obradi",
    DOWNLOAD_INVOICE:"Preuzmite fakturu",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Kliknite opcije za preuzimanje",
    B2B_SPEC:"B2B Specifikacija",
    B2C_SPEC:"B2C Specifikacija",
    DOWNLOAD_PAYMENT_REQUEST:"Preuzmite zahtjev za plaćanje",
    LOYALTY_PREVIEW:"Pregled kampanje",
    ACTIVATED:"Aktivna",
    RUNNING:"Traje",
    NOT_ACTIVATED:"Nije aktivna",
    FINISHED:"Završena",
    DEPRECATED:"Obustavljena",
    UPCOMING:"Nadolazeća",
    NONE:"Nitko",
    STARTED:"Počela",
    ENDS:"Završava se",
    DEDICATED:"Posvećena",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Pokušavate se aktivirati",
    CAMPAIGN:"kampanju",
    SEND_MESSAGE_NOTIFICATION:"Da želite poslati poruku svim korisničkim grupama",
    DIVISIBLE_TO_NUMBER:"Broj bi trebao biti djeljiv s ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Tip uređaja",
    LISTENER:"Mali stroj",
    BRIDGE:"Boxovi za pranje",
    WASH_BOXES:"Boxovi za pranje",
    VACUUMS:"Usisavači",
    SAVE_NEWS:"Spremite vijest",
    CREATE_NEW_NEWS:"Kreiraj novu vijest",
    HISTORY_OF_ALL_NEWS:"Povijest svih vijesti",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Upiši ime praonice",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Dodaj novu praonicu",
    NEWS_TEXT:"Tekst vijesti",
    NEWS_TITLE:"Naslov vijesti",
    DELETE_NEWS_CONFIRMATION:"želite obrisati vijest ?",
    NEWS_DELETE_NOTIFICATION:"Uspješno ste obrisali vijest",
    NEWS_SAVE_NOTIFICATION:"Uspješno ste spremili vijest",
    NEWS_CREATION_DATE:"Datum kreiranja",
    NO_TITLE:"Nema naslova",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Tekst vijesti nesmije biti duži od 255 znakova",
    NEWS_TEXT_REQUIRED_VALIDATION:"Tekst vijesti je obavezan",
    NEWS_TITLE_REQUIRED_VALIDATION:"Naslov vijesti je obavezan",
    DEACTIVATE:"Deaktiviraj",
    ASIDE_MENU_LOCAL_TOKENS:"Lokalni žetoni",
    CREATE_NEW_LOCAL_TOKENS:"Izdavanje novih lokalnih žetona",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Unesite email adresu korisnika i broj žetona koje mu želite izdati",
    CREATE_TOKENS:"Izdaj žetone",
    MINIMUM_ONE_TOKEN:"Vrijednost mora biti veća od 0",
    CUSTOMER_EMAIL:"Korisnikova email adresa",
    AMOUNT_OF_TOKENS:"Broj žetona",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Uspješno ste izdali lokalne žetone na",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Dogodila se greška prilikom izdavanja žetona. Molimo Vas provjerite korisnikovu email adresu i pokušajte ponovno.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Pregled izdanih lokalnih žetona",
    ISSUED_AT:"Vrijeme izdavanja",
    ISSUED_BY:"Izdano od",
    CODE:"Kod",
    REDEEMED_BY:"Iskorišteno od",
    REDEEMED_AT:"Vrijeme",
    ASIDE_MENU_VOUCHERS:"Vaučeri",
    PRINT:"Štampa",
    VOUCHERS_OVERVIEW:"Pregled vaučera",
    CREATE_NEW_VOUCHERS:"Kreiranje novih vaučera",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Kreirajte novu seriju vaučera unošenjem broja žetona po vaučeru, količine vaučera u seriji i prefiks koda za seriju",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Broj žetona po vaučeru",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Dozvoljeno je dodijeliti između 1 i 100 žetona po vaučeru",
    NUMBER_OF_NEW_VOUCHERS:"Količina vaučera u seriji",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Dozvoljeno je kreiranje između 1 i {{size}} vaučera u jednoj seriji",
    NEW_VOUCHERS_PREFIX:"Prefiks kod vaučera u seriji",
    VALIDATION_VOUCHER_PREFIX:"Prefiks kod mora sadržavati točno 4 heksadecimalna znaka (0-9, A-F)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Dogodio se problem prilikom kreiranja novih vaučera. Molimo Vas pokušajte ponovo ili kotaktirajte tehničku podršku.",
    CREATE_VOUCHERS:"Kreiraj seriju vaučera",
    CREATING_VOUCHERS_SUCCESS:"Nova serija vaučera uspješno kreirana",
    PRINT_NEW_VOUCHERS:"Printaj vaučere",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Unesite broj serije vaučera, cijeli kod ili dio koda vaučera, kako bi isprintali odgovarajuće vaučere.",
    PRINT_VOUCHERS_PREFIX:"Prefiks kod (serija) vaučera",
    NO_VOUCHERS_FOR_PRINT:"Nema vaučera za printanje sa unesenim prefix kodom",
    PRINT_VOUCHERS:"Printaj vaučere",
    VALIDATION_VOUCHER_CODE_FILTER:"Prefiks kod filter može sadržavati između 1 i 16 znakova i podržava samo velika slova i brojeve.",
    FILTER_VOUCHERS_BY_CODE:"Filter vaučera po kodu",
    FILTER_VOUCHERS:"Filter",
    WASH_BOX:"Box za pranje",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Ukupno iskorišćenih digitalnih žetona",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Ukupno kupljenih lokalnih žetona",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Ukupno potrošenih lokalnih žetona",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Ukupno poklonjenih lokalnih žetona",
    LOCAL_TOKEN:"Lokalni žeton",
    GIVEN_TOKEN:"Poklonjeni žetoni",
    SOLD_TOKEN:"Kupljeni žetoni",
    SMALL_MACHINES:"Mali strojevi",
    R2W_Listener:"Listener",
    HHANLE_DEVICE:"HHanle - Box za pranje",
    CODE_PREFIX_EXIST:"Code prefix već postoji",
    CODE_PREFIX_EXIST_TEXT:"Ne možete kreirati novi voucher sa ovim code prefix-om. Definišite novi.",
    MIN_FOUR_VALIDATION:"Točno 4 znaka",
    ALL_INFORMATION_1:"Sve informacije o",
    ALL_INFORMATION_2:"će biti izgubljene",
    ASIDE_MENU_TRANSACTIONS:"Transakcije",
    EXPENSES:"Troškovi",
    TOPUPS:"Kupljeni žetoni",
    EXPENSES_LIST:"Popis troškova",
    USER_EMAIL:"E-pošte korisnika",
    COMPANY_NAME:"Naziv tvrtke",
    TOPUPS_LIST:"Popis kupljenih žetona",
    CONSUMER:"Consumer",
    SYSTEM_ADMIN:"System administrator",
    MERCHANT_ADMIN:"Merchant administrator",
    COMPANY_ADMIN:"Company administrator",
    FACILITY_ADMIN:"Facility administator",
    SUBSCRIBER:"Subscriber",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Serijski broj",
    SETUP_UNIT_MATERIAL_NO:"Broj materijala",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi verzija",
    TOTAL_TURNOVER:"Promet autopraonice",
    AVAILABILITY_ALL:"Dostupnost",
    AVAILIBILITY:"Dostupnost boxova za pranje:",
    AVAILABILITY_VACUUMS:"Dostupnost usisavača:",
    WASH_BOX_INFO:" Informacije o boxovima za pranje",
    VACUUM_CLEANER_INFO:"Informacije o usisavačima",
    BREAD_CRUMBS_SERVICE:"Servis",
    HOLIDAYS:"Blagdani",
    HOLIDAY:"Blagdan",
    LIGHTS_ON:"Svjetla upaljena",
    LIGHTS_OFF:"Svjetla ugašena",
    WASH_BOXES_ON:"Box za pranje uključen",
    WASH_BOXES_OFF:"Box za pranje isključen",
    VACUUMS_ON:"Usisavač uključen",
    VACUUMS_OFF:"Usisavač isključen",
    TURNOVER:"Promet",
    TURNOVER_MANUAL_WASH_UNIT:"Priručnik za promet",
    STATUS_BAY_RUN_TIME:"Ukupno radno vrijeme boxa",
    STATUS_BAY_PROGRAM_NAME:"Naziv programa",
    STATUS_BAY_CREDIT:"Kredit za boxeve za pranje",
    CLOUD_KREDIT:"Cloud kredit",
    STATUS_VACUUM_RUN_TIME:"Ukupno radno vrijeme usisavača",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Usluge objekta, program boxa i informacije o trenutnim greškama",
    UNAVAILABLE:"Jedinica je zauzeta",
    SHOW_HIDE_TABLE:"Prikaži/sakrij tabelu radnog vremena",
    PROGRAM_NAME:"Naziv programa",
    PROGRAM_OPTION:"Opcija programa",
    DEVICE:"Uređaj",
    QUANTITY:"Količina",
    PROGRAM_COUNTER:"Brojač programa",
    NO_NAME:"Referenca nema ime",
    COUNTER_SERVICE_DATA:"Podaci o servisu",
    NEED_SERVICE:"Potreban servis",
    PROGRAM_DATA:"Podaci o programu boxa",
    CURRENT_FAULT_DATA:"Trenutni podaci o kvaru",
    REFERENCE_DUE:"Rok",
    REFERENCE_SECONDS:"Sekunde",
    REFERENCE_NAME:"Naziv dijela",
    WASHBOX_NAME:"Naziv boxa",
    FAULT_NAME:"Naziv kvara",
    FAULT_NUMBER:"Broj kvara",
    CURRENT_FAULT_COUNT:"Aktivni kvarovi",
    DEVICE_NOT_INSTALLED:"Uređaj nije instaliran",
    STATUS_READY:"Spreman",
    STATUS_ERROR:"Greška",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Softverska greška",
    SOFTWARE_RESET:"Softverska greška",
    EXTERNAL_PIN_RESET:"Softverska greška",
    RESTART_OR_BROWNOUT_OCCURRED:"Softverska greška",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Hardverska greška",
    COULD_NOT_SIMULATE_COIN:"Hardverska greška",
    ERROR_SETTING_INHIBIT_MODE:"Hardverska greška",
    OFFLINE_DEVICE:"Offline autopraonica",
    TARIFFS:"Tarife",
    DAY:"Dan",
    NIGHT:"Noć",
    VOUCHER_CODE:"Kod vaučera",
    DISMISS_ALARM:"Resetirati alarm?",
    ALARM_ACTIVE:"Aktivni alarmi",
    NO_ALARM_ACTIVE:"Nema aktivnih alarma",
    ALARM_HISTORY:"Povijest upozorenja",
    MANAGING_TOKENS:"Upravljanje lokalnim žetonima",
    EXPIRATION_DATE:"Rok trajanja",
    EXTEND_TOKEN_DATE:"Produlji datum isteka žetona za",
    DELETE_TOKENS_FOR:"Izbrišite lokalne žetone za",
    PUMP_TYPE:"Tip pumpe",
    TURN_OFF_DEVICE:"Status uređaja",
    OPERATION_DATA:"Podaci o radu",
    PUMP_DATA:"Podaci o pumpi",
    PUMP_NAME:"Naziv pumpe",
    POINT_NAME:"Naziv tačke",
    CHANGER_INCOME:"Ukupni prihod od mijenjača po datumu",
    SELECTED_OPEN:"Otvoreno u odabrano radno vrijeme",
    ALWAYS_OPEN:"Uvijek otvoreno (24/7)",
    CLOSED:"Zatvoreno",
    CLOSED_24:"Zatvoreno 24h",
    OPENED_24:"Otvoreno 24h",
    MON:"Ponedjeljak",
    TUE:"Utorak",
    WED:"Srijeda",
    THU:"Četvrtak",
    FRI:"Petak",
    SAT:"Subota",
    SUN:"Nedjelja",
    PRICING:"Cjenovnik",
    PRICE:"Cijena",
    VALIDITY:"Validnosti",
    TOKEN_PACKAGES:"Paketi žetona",
    SINGLE_WASH:"Jedno pranje",
    FACILITY_WORKING_HOURS:"Postavite radno vrijeme za odabrani objekt",
    WORKING_HOURS_ALWAYS_OPEN:"Uvijek otvoreno ",
    WORKING_HOURS_ALWAYS_CLOSE:"Zatvoreno od strane operatera",
    WORKING_HOURS_CUSTOM:"Postavite radno vrijeme",
    KARCHER_ERROR_CODE:"Kod greške upozorenja",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor BUFFER TANK EMPTY activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor BUFFER CONTAINER EMPTY and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor RO PUMP ON and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Organizacija",
    CREATE_ORGANIZATION:"Kreiraj organizaciju",
    CREATE_ORGANIZATION_AS:"Kreiraj organizaciju kao podorganizaciju za",
    DELETE_ORGANIZATION:"Izbriši organizaciju",
    EDIT_ORGANIZATION:"Uredi organizaciju",
    SUPPORTED_ORG_NAME:"Podržana organizacija",
    SUPPORTED_ORG_TYPE:"Podržani tip",
    ORG_NAME:"Naziv",
    ORG_TYPE:"Tip",
    SET_ORG_TITLE:"Postavi podorganizaciju",
    SET_SUPPORTED_ORG_TITLE:"Postavi podržanu podorganizaciju",
    SAVE_ORGANIZATION:"Sačuvaj organizaciju",
    SELECT_ORGANIZATION_TYPE:"Odaberite tip organizacije",
    SELECT_ORGANIZATION_SELECTOR:"Odaberi",
    SELECT_SUPPORTED_ORGANIZATION:"Odaberite podržanu organizaciju",
    ORGANIZATION_DELETED:"Organizacija uspješno izbrisana",
    ORGANIZATION_SAVED:"Organizacija uspješno spremljena",
    ORGANIZATION_UPDATED:"Organizacija uspješno ažurirana",
    ALERTS:"Upozorenja",
    DEVICE_STATUS:"Status uređaja",
    SITE_DETAILS:"Detalji autopraone",
    ALARM_STATUS:"Status upozorenja",
    FILTER:"Filtriraj po...",
    FILTER_BY_ALERT_CENTER:"Filtriraj po kodu, nazivu ili opisu",
    TOTAL_ALARM:"Svi alarmi",
    LOW_ALARM:"Događaj",
    MEDIUM_ALARM:"Kvar",
    HIGH_ALARM:"Kritičan kvar",
    NO_FACILITIES_NEARBY:"Nema obližnjih autopraona",
    GRAY_MAP:"Mapa s sivim stilom",
    READY:"Spreman",
    WARNING:"Kvar",
    ERROR:"Greška",
    SITE_NAME:"Naziv autopraonice",
    ACCOUNTS_INFO:"Informacije o nalogu",
    USER_ORGANIZATION:"Korisnička organizacija",
    ADD_USER_ORGANIZATION:"Dodaj novog korisnika organizacije",
    EDIT_USER_ORGANIZATION:"Uredi korisnike organizacije",
    SELECT_ROLE:"Odaberi ulogu",
    SELECT_ORGANIZATION:"Odaberi organizaciju",
    SELECT_USER:"Odaberi korisnika",
    USER_FOR_ORGANIZATION_CREATED:"Novi korisnik uspješno kreiran",
    SELECT_REGION:"Odaberite region",
    SELECT_LANGUAGE:"Odaberite jezik",
    LOADING_DATA:"Učitavanje podataka, molimo pričekajte ...",
    ADMINISTRATOR:"Administrator",
    TECHNICAL_SUPPORT:"Tehnička podrška",
    CONTROLLER:"Kontroler",
    EDIT_ORGANIZATION_USER:"Uredi korisnike organizacije",
    DELETE_ORGANIZATION_USER:"Izbriši korisnike organizacije",
    USER_UPDATED:"Korisnik uspješno ažuriran",
    USER_CREATED:"Korisnik uspješno kreiran",
    ADDRESS:"Adresa",
    SUBSCRIPTIONS:"Pretplate",
    RESOLVED_STATUS:"Riješeno",
    NOT_RESOLVED_STATUS:"Nije riješeno",
    ALERT_NAME:"Naziv upozorenja",
    ALERT_DESCRIPTION:"Opis upozorenja",
    ALERT_CODE:"Kod upozorenja",
    ALERT_TYPE:"Vrsta upozorenja",
    UNSUBSCRIBE:"Otpratite upozorenje",
    SUBSCRIBE:"Zapratite upozorenje",
    ALARM_SUBSCRIBED:"Uspješno zapraćeno",
    UNSUBSCRIBED_CONFIRM:"Otpratiti?",
    ALARM_UNSUBSCRIBED:"Uspješno otrpraćeno",
    ASIDE_MENU_CASHLESS_SALES:"Bezgotovisnka prodaja",
    FILTERED_CASHLESS_PAYMENTS:"Filtrirane bezgotovinske uplate",
    REFUND_DIALOG_TITLE:"Povrat transakcije?",
    REFUND_DIALOG_SUBTITLE:"Iznos može biti manji ili jednak iznosu transakcije",
    REFUND:"Povrat",
    INPUT_NOT_VALID:"Unos nije važeći",
    REFUND_SUCCESSFULLY:"Povrat za odabranu uplatu uspješno izvršen",
    CARD_LAST_DIGITS:"Zadnje znamenke kartice",
    PAYMENT_BRAND:"Marka plaćanja",
    REFUNDED_AMOUNT:"Vraćeni iznos",
    MERCHANT_REFUND_SPLIT:"Udio povrata za trgovca",
    USER:"Korisnik",
    TRANSACTION_ID:"PSP referenca",
    DEVICE_ID:"ID uređaja",
    NET_AMOUNT:"Neto iznos",
    TRANSACTION_STATUS:"Status transakcije",
    REPORT_NAME:"Naziv izvještaja",
    TIME_FRAME:"Vremenski okvir",
    SUB_POINT:"Odaberi podtočku",
    SUB_POINT_LIST_NOT_EXIST:"Popis podtočaka ne postoji za odabrani objekt za pranje",
    FACILITY_TYPE:"Vrsta uređaja",
    MACHINE_NAME:"Naziv stroja",
    WASH_FACILITY_DETAILS:"Detalji uređaja",
    WASH_BAY_DETAILS:"Detalji boxa za pranje",
    DEVICES_INFO:"Lista uređaja",
    OPERATION_TIME_INFO:"Vrijeme rada",
    OPERATION_TIME_VACUUM_INFO:"Vrijeme rada usisavača",
    OPERATION_TIME_ILLUMINATION_INFO:"Vrijeme rada za osvjetljenje",
    AVAILABLE_TITLE:"Dostupno",
    UNAVAILABLE_TITLE:"Nedostupno",
    CURRENT_PROGRAM:"Trenutni program",
    CREDITS:"Krediti",
    DEVICE_NAME:"Naziv uređaja",
    ACTIVE_ALARMS:"Aktivna upozorenja",
    ALL_DAY:"Cijeli dan",
    OPERATING_TIME_WASH_FACILITY:"Sustav samoposlužnog pranja",
    OPERATING_TIME_VACUUMS:"Usisavači",
    OPERATING_TIME_ILLUMINATION:"Osvjetljenje",
    OPERATION_COUNTERS:"Brojači rada",
    EDIT:"Uredi",
    WASHING_PROGRAMS:"Programi pranja",
    INFO:"Događaj",
    STATISTIC:"Statistika",
    ROLLOVER_DOSING:"Doziranje",
    ROLLOVER_SPEED:"Brzine",
    ROLLOVER_RESETS:"Daljinsko resetiranje sustava četki",
    ROLLOVER_RESETS_INFO:"Daljinsko resetiranje mora biti u skladu s lokalnim propisima. Važno: Prije resetiranja provjerite je li sustav četki prazan.",
    RESET_ROLLOVER:"Resetiraj četke",
    OPEN_DOOR_ROLLOVER:"Otvori",
    ROLLOVER_OPEN_DOOR_INFO:"Otvori vrata za pranje. Budite oprezni.",
    ROLLOVER_OPEN_DOOR:"Otvori vrata",
    APPLY_DOSING_CHANGES:"Primijeni promjene doziranja",
    APPLY_SPEED_CHANGES:"Primijeni promjene brzine",
    ACTUATION_SUCCESS:"Zahtjev poslan",
    REMAINING_TIME:"Preostalo vrijeme",
    OPEN_24H:"Otvoreno 24h",
    CLOSE_24H:"Zatvoreno 24h",
    VALIDATION_OPERATION_TIME:"Format nije ispravan. Koristite hh:mm",
    ROLLOVER:"Četke",
    UPDATE_WASHING_PROGRAM:"Ažuriraj program pranja",
    UPDATE_ACTUATORS:"Ažuriraj aktuatore",
    OPEN_ROLOVER_DOOR_TITLE:"Želite otvoriti vrata četki za pranje?",
    OPEN_ROLOVER_DOOR_CONTENT:"Jeste li sigurni da želite otvoriti vrata?",
    RESET_ROLOVER_TITLE:"Želite li resetirati četku?",
    RESET_ROLOVER_CONTENT:"Jeste li sigurni da želite resetirati četku?",
    G0:"{{brand === 'r2w' ? 'Box 0' : 'Box 1'}}",
    G1:"{{brand === 'r2w' ? 'Box 1' : 'Box 2'}}",
    G2:"{{brand === 'r2w' ? 'Box 2' : 'Box 3'}}",
    G3:"{{brand === 'r2w' ? 'Box 3' : 'Box 4'}}",
    G4:"{{brand === 'r2w' ? 'Box 4' : 'Box 5'}}",
    G5:"{{brand === 'r2w' ? 'Box 5' : 'Box 6'}}",
    G6:"{{brand === 'r2w' ? 'Box 6' : 'Box 7'}}",
    G7:"{{brand === 'r2w' ? 'Box 7' : 'Box 8'}}",
    G8:"{{brand === 'r2w' ? 'Box 8' : 'Box 9'}}",
    G9:"{{brand === 'r2w' ? 'Box 9' : 'Box 10'}}",
    G10:"{{brand === 'r2w' ? 'Box 10' : 'Box 11'}}",
    U0:"{{brand === 'r2w' ? 'Usisavač 0' : 'Usisavač 1'}}",
    U1:"{{brand === 'r2w' ? 'Usisavač 1' : 'Usisavač 2'}}",
    U2:"{{brand === 'r2w' ? 'Usisavač 2' : 'Usisavač 3'}}",
    U3:"{{brand === 'r2w' ? 'Usisavač 3' : 'Usisavač 4'}}",
    U4:"{{brand === 'r2w' ? 'Usisavač 4' : 'Usisavač 5'}}",
    U5:"{{brand === 'r2w' ? 'Usisavač 5' : 'Usisavač 6'}}",
    U6:"{{brand === 'r2w' ? 'Usisavač 6' : 'Usisavač 7'}}",
    U7:"{{brand === 'r2w' ? 'Usisavač 7' : 'Usisavač 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Izvještaj centra upozorenja stvoren odabrane lokacije s nadzorne ploče",
    ALERT_CENTER_TITLE_BY_FACILITY:"Izvještaj centra upozorenja stvoren odabrane objekta s nadzorne ploče",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Izvještaj centra upozorenja",
    ERROR_MESSAGE_403:"Nemate privilegiju za korištenje ove API poziva. Pogreška kod: 403",
    LAST_ACTIVE_PROGRAM:"Zadnji aktivni program",
    PROGRAM_ID:"Broj programa",
    PROGRAM_PRICE:"Cijena programa",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Potrebno nadopuniti",
    EMPTY_CHEMICAL_LEVEL:"Prazno",
    CHEMICAL_LEVEL:"Indikacija nivoa deterdženata (%)",
    ROLLOVER_STATUS:"Stanje rollovera",
    ROLLOVER_STATUS_CODE_0:"Perionica trenutno izvan pogona",
    ROLLOVER_STATUS_CODE_1:"Izvan radnog vremena",
    ROLLOVER_STATUS_CODE_2:"Dopušten ulazak u program",
    ROLLOVER_STATUS_CODE_3:"Pozicionirajte vozilo",
    ROLLOVER_STATUS_CODE_4:"Vozilo naprijed",
    ROLLOVER_STATUS_CODE_5:"Vozilo natrag",
    ROLLOVER_STATUS_CODE_6:"Zaustavljanje vozila",
    ROLLOVER_STATUS_CODE_7:"Perionica aktivna",
    ROLLOVER_STATUS_CODE_8:"Perionica zaustavljena",
    ROLLOVER_STATUS_CODE_9:"Perionica aktivna (takt)",
    ROLLOVER_STATUS_CODE_10:"Izlazak vozila unatrag",
    ROLLOVER_STATUS_CODE_11:"Hitno zaustavljanje",
    ROLLOVER_STATUS_CODE_12:"Izlazak vozila prema naprijed",
    ROLLOVER_STATUS_CODE_13:"Aktiviran protiv smrzavanja",
    ROLLOVER_STATUS_CODE_14:"Prednji sigurnosni prekidač aktiviran",
    ROLLOVER_STATUS_CODE_15:"Zadnji sigurnosni prekidač aktiviran",
    ROLLOVER_STATUS_CODE_16:"Lijevi prednji sigurnosni prekidač aktiviran",
    ROLLOVER_STATUS_CODE_17:"Desni prednji sigurnosni prekidač aktiviran",
    ROLLOVER_STATUS_CODE_18:"Lijevi stražnji sigurnosni prekidač aktiviran",
    ROLLOVER_STATUS_CODE_19:"Desni stražnji sigurnosni prekidač aktiviran",
    ROLLOVER_STATUS_CODE_20:"Vozilo je prešlo predaleko ulijevo",
    ROLLOVER_STATUS_CODE_21:"Vozilo je prešlo predaleko udesno",
    ROLLOVER_STATUS_CODE_22:"Lijeva vrata nisu zatvorena",
    ROLLOVER_STATUS_CODE_23:"Desna vrata nisu zatvorena",
    ROLLOVER_STATUS_CODE_24:"Detektiran transporter, odabran je pogrešan program pranja",
    ROLLOVER_STATUS_CODE_25:"Senzor sirene",
    ROLLOVER_STATUS_CODE_98:"Ručni / prilagodbeni način",
    ROLLOVER_STATUS_CODE_99:"Nepoznati status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Neodređeni statusni kod",
    ALARM:"Kritični kvar",
    NO_ALARM:"Nema kritičnih kvarova",
    SOFTWARE_VERSION:"Softverska verzija",
    SOFTWARE_DATE:"Datum softvera",
    SITE_ADDRESS:"Adresa autopraone",
    SECONDS:"Sekunde",
    SERVICE_PART_NAME:"Naziv usluge:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Brojač rada i održavanja",
    OPERATION_COUNTER:"Brojač rada",
    SERVICE_COUNTER:"Brojač održavanja",
    FAULT_CODE:"Kod upozorenja",
    PRESSURE_TITLE:"Zračni tlak",
    TIME_TITLE:"Trenutno vrijeme",
    COUNTRY_TITLE:"Država",
    CITY_TITLE:"Grad",
    REGION_TITLE:"Region",
    SELECT_POINTS_TO_SEARCH:"Odabir točaka ...",
    LOGS_HISTORY:"Povijest promjene parametara",
    ACTUATOR_REFERENCE:"Referenca aktuatora",
    ACTUATOR_VALUE:"Vrijednost aktuatora",
    POINT_ID:"ID točke",
    VALIDATION_NOT_VALID_RANGE:"Pogrešan raspon",
    ENABLE_ROLLOVER_RESET:"Označavanjem ove kućice potvrđujete da ste pročitali i slažete se s sigurnosnim uputama.",
    CHANGE_OF_PARAMETERS:"Promjena parametara",
    SELECT_OPTIONS:"Odabir opcija",
    AUTOMATIC:"Automatski",
    DESALTING:"Funkcija odstranjivanja soli",
    SEASON_WASH:"Programi pranja za sezonu",
    SPRING_PROGRAM:"Programi pranja za proljeće",
    SUMMER_PROGRAM:"Programi pranja za ljeto",
    AUTUMN_PROGRAM:"Programi pranja za jesen",
    WINTER_PROGRAM:"Programi pranja za zimu",
    DOOR_CONTROL:"Upravljanje vratima",
    SUMMER_DOOR_CONTROL:"Ljeto, rad s upravljanjem vratima u ljetnom načinu rada",
    WINTER_DOOR_CONTROL:"Zima, rad s upravljanjem vratima u zimskom načinu rada",
    APPLY_PARAMETERS_CHANGES:"Primijeni promjene parametara",
    WORKING_SCHEDULES:"Radni rasporedi",
    HOLIDAY_SCHEDULES:"Rasporedi blagdana",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Blagdani za autopraonu uspješno kreirani",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Blagdani za autopraonu uspješno ažurirani",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Blagdani za autopraonu uspješno obrisani",
    WORKING_SCHEDULES_SUCCESSFULLY_UPDATED:"Radni rasporedi za autopraonu uspješno ažurirani",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Radni rasporedi uspješno propagirani",
    HOLIDAY_SUCCESSFULLY_DELETED:"Praznik uspješno izbrisan",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:" CW1_3_0_0_Trans",
    CW1_3_1_0:" CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Sredstvo za sušenje s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_SHAMPOO:"Šampon s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_FOAM:"Pjena s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_WAX_1:"Vosak s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_POLISH_1:"Poliranje s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Čistač felgi s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_WAX_2:"Vosak s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Sjaj guma s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Sredstvo za uklanjanje insekata s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_POLISH_2:"Poliranje s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_INTENSIVE:"Intenzivno s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Pjena za kišu s niskim nivoom punjenja",
    CHEM_LEVEL_DRYING_AGENT:"Nivo punjenja sredstva za sušenje",
    CHEM_LEVEL_SHAMPOO:" Nivo punjenja šampona",
    CHEM_LEVEL_FOAM:"Nivo punjenja pjene",
    CHEM_LEVEL_WAX_1:"Nivo punjenja voska",
    CHEM_LEVEL_POLISH_1:"Nivo punjenja poliranja",
    CHEM_LEVEL_RIM_CLEANER:"Nivo punjenja čistača felgi",
    CHEM_LEVEL_WAX_2:"Nivo punjenja voska",
    CHEM_LEVEL_TYRE_SHINE:" Nivo punjenja sjaja guma",
    CHEM_LEVEL_INSECT_REMOVER:"Nivo punjenja sredstva za uklanjanje insekata",
    CHEM_LEVEL_POLISH_2:"Nivo punjenja poliranja",
    CHEM_LEVEL_INTENSIVE:"Nivo punjenja intenzivnog",
    CHEM_LEVEL_FOAM_RAIN:"Nivo punjenja pjene za kišu",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Brojač servisa za podizanje krovnih četki",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Brojač servisa za podizanje sušača",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Brojač servisa za motorne kablove krovnih četki",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Brojač servisa za servisiranje pumpe za svježu vodu",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Brojač servisa za servisiranje pumpe za korištenu vodu",
    DRYING_AGENT:"Sredstvo za sušenje",
    FOAM_DRYING_AGENT:"Pjena sredstva za sušenje",
    SHAMPOO:"Šampon",
    FOAM:"Pjena",
    BRUSH_FOAM:"Pjena za četke",
    WAX_1:"Vosak",
    FOAM_WAX_1:"Pjenušavi vosak",
    POLISH_1:"Poliranje",
    RIM_CLEANING:"Čistač felgi",
    WAX_2:"Vosak",
    FOAM_WAX_2:"Pjenušavi vosak",
    TYRE_SHINE:"Sjaj za gume",
    INSECT_REMOVER:"Sredstvo za uklanjanje insekata",
    POLISH_2:"Poliranje",
    INTENSIVE_BASIC:"Intenzivno osnovno",
    INTENSIVE_SIDE:"Intenzivno bočno",
    INTENSIVE_ROOF_SPRAY_BAR:"Intenzivno prskanje krovne trake",
    TAR_REMOVER:"Odstranjivač katrana",
    UNDER_CHASSIS_CONVERSATION:"Razgovor o podvozju",
    STATIONARY_PRE_SPRAY_ARCH:"Stacionarni pred-sprej lukova",
    FOAM_RAIN:"Pjena za kišu",
    PRE_CLEANING:"Prečišćavanje",
    BRUSH:"Četka",
    CARE:"Nega",
    DRYING:"Sušenje",
    DRYING_LOW_NOISE:"Smanjenje buke prilikom sušenja",
    INTENSIVE_CLEANING:"Intenzivno čišćenje",
    BRUSH_CLEANING:"Čišćenje četkom",
    EMPTY_RUN:"Prazan ciklus",
    DRYING_AID:"Pomoć pri sušenju",
    WAX:"Vosak",
    FOAM_WASH:"Pjenušavi vosak",
    POLISH:"Poliranje",
    FOAM_POLISH:"Pjenušavo poliranje",
    WHEEL_CLEANING:"Čišćenje točkova",
    HIGH_PRESSURE_ROOF:"Visoki pritisak na krovu",
    HIGH_PRESSURE_SIDE:"Visoki pritisak sa strane",
    DRYER_FORWARD:"Sušilica prema naprijed",
    DRYER_BACKWARD:"Sušilica unatrag",
    DELETE_ALL_HOLIDAYS:"Izbriši sve praznike za odabranu lokaciju",
    CREATE_NEW_HOLIDAY:"Kreiraj nove blagdane",
    RESET_INPUTS:"Poništi sve unose blagdana",
    TWENTY_FOUR_HOURS_OPEN:"Otvoreno 24h",
    EVERY_YEAR:"Godišnje",
    DELETE_HOLIDAY:"Obriši blagdan",
    ADD_NEW_HOLIDAY:"Dodaj novi blagdan",
    HOLIDAYS_LIST:"Lista postojećih blagdana",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Izbrisati sve praznike za odabranu praonu?",
    VALIDATION_HOLIDAY_DATE:"Format nije ispravan. Koristite mm-dd",
    FOR_DATE:"Za datum",
    WITH_ID:"Sa ID",
    FROM_HOURS:"Od (h)",
    FROM_MINUTES:"Od (min)",
    TO_HOURS:"Do (h)",
    TO_MINUTES:" Do (min)",
    NOT_MATCH:"Ne podudara se",
    START:"Od",
    STOP:"Do",
    DAILY_TIME:"Popis od 24 sata",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Postavljanje individualnog vremena",
    PROGRAM_NOT_STARTED:"Program još nije počeo",
    JETWASH:"Sustav za samoposlužno pranje",
    KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
    KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
    KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
    KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
    KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
    KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
    KARCHER_REPORT_7:"Rollover: Amount of power supply failures",
    KARCHER_REPORT_8:"SB-Units: Amount of hours per washing program filtered by bay and in total",
    KARCHER_REPORT_9:"SB-Units: Turnover indication per wash bay and in total",
    KARCHER_REPORT_10:"SB-Units: Tokens/Coins counter per coin channel",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Pumpa za svježu vodu",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Pumpa za procesnu vodu",
    OPERATION_COUNTER_HP_PUMP_1:"Visokotlačna pumpa 1",
    OPERATION_COUNTER_HP_PUMP_2:"Visokotlačna pumpa 2",
    RELEASE_NOTES:"Verzije aplikacije i bilješke o izdanju",
    BACKEND_RELEASE_NOTES:"Bilješke o izdanju platforme:",
    FRONTEND_RELEASE_NOTES:"Bilješke o izdanju web aplikacije:",
    SELECTED_FACILITY_TIMEZONE:"Vremenska zona za odabrani uređaj za pranje:",
    REFRESH_PAGE:"Osvježi stranicu",
    REFRESH_MAPS:"Osvježi mapu",
    PUMPS:"Pumpe",
    RUN_TIME:"Vrijeme rada ",
    RUN_TIME1:"Vrijeme rada 1",
    RUN_TIME2:"Vrijeme rada 2",
    PROGRAM_RUNTIME_ACTUATOR:"Aktuator za vrijeme rada",
    PROGRAM_RUNTIME_ACTUATOR_1:"Aktuator za vrijeme rada 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Aktuator za vrijeme rada 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Minimalna vrijednost je 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Maksimalna vrijednost je 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Koristite format cijene x.xx",
    ACTUATION_NOT_ALLOWED:"Aktuacija nije dopuštena za trenutnu ulogu korisnika",
    MAINTENANCE_DAYS:"Dani održavanja",
    MAINTENANCE_WASHES:"Pranja za održavanje",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Ukupni prihod POS",
    PROPAGATE:"Proširite",
    ALL_DAY_HOURS_SELECTOR:"Selektor tipa 24 sata",
    GET_OPERATING_TIME_FROM_SITE:"Dohvatite vrijeme rada za trenutni uređaj iz radnih rasporeda web stranice",
    USER_NOT_VALID:"Korisnik nije važeći. Pokušajte s drugim korisničkim podacima.",
    VERIFIED:"Verifikovano",
    RESEND_VERIFICATION_MAIL:"Ponovno pošalji verifikacijski email",
    RETURN_TO_DASHBOARD:"Povratak na pregled praonica",
    ERROR_PAGE_BAD_REQUEST:" 400 Bad Request.",
    WASHES:"Broj pranja",
    TIME_TO_SERVICE:"Vrijeme do servisa",
    ACCOUNT_ALREADY_ACTIVATED:"Nalog već aktiviran",
    DEVICE_EVENTS:" Događaji uređaja",
    DEVICE_EVENTS_LOG_PULLED:"Preuzet zapisnik događaja za uređaj",
    EVENTS_PULL_DATE:"Vrijeme preuzetih događaja",
    DEVICE_EVENTS_REFRESH:"Preuzmi nove podatke događaja",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Problem s povezivanjem web socketa. Pokušajte osvježiti stranicu.",
    INSTALLATION_DATE:"Datum instalacije stroja",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Vrući vosak",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Pranje pod visokim pritiskom",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Pjena za naplatke",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Snažna pjena",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Zaustavi",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Pjensko pranje HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Pranje",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Vrhunska njega",
    INFO_TITLE:"Informacije",
    FOAM_WAX1:"Pjenušavi vosak",
    POLISH1:"Poliranje",
    WAX1:"Vosak",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Podaci o lokaciji uspješno ažurirani",
    COMPANY:"Tvrtka",
    FACILITY_HAS_CHANGER:"Imate li mjenjač?",
    DISABLE_OFFLINE_ALARM:"Onemogući R2W alarme",
    ASIDE_WORKING_SCHEDULES:"Podaci o lokaciji aplikacije",
    TERMS_OF_SERVICE_R2W_TITLE:"Uvjeti korištenja Ready2Wash",
    TERMS_OF_SERVICE_R2W:"Uvjeti korištenja Ready2Wash",
    DATA_PROCESSING_TITLE:"Obrada podataka",
    PRIVACY_POLICY_TITLE:" Pravila privatnosti",
    READY_TO_PAY_TERMS_OF_SERVICE:"Uvjeti korištenja Ready2Pay",
    TERMS_AND_SERVICES:"Uvjeti i usluge",
    HOURLY: "Svakih sat vremena",
    DAILY: "Dnevno",
    WEEKLY: "Tjedno",
    MONTHLY: "Mjesečno",
    YEARLY: "Godišnje",
    DELETE_ITEM_SUCCESS:"Uspešno ste obrisali izabran element",
    STATE: "Stanje",
    AVAILABILITY_STATUS_1: "Jedinica otvorena",
    AVAILABILITY_STATUS_2: "Jedinica zatvorena (odmor)",
    AVAILABILITY_STATUS_3: "Jedinica zatvorena (radno vrijeme)",
    AVAILABILITY_STATUS_4: "Jedinica zatvorena (kvar)",
    AVAILABILITY_STATUS_5: "Jedinica zatvorena (ostalo)",
    AVAILABILITY_VACUUMS_STATUS_1: "Usisavači nisu instalirani",
    AVAILABILITY_VACUUMS_STATUS_2: "Usisavači otvoreni",
    AVAILABILITY_VACUUMS_STATUS_3: "Usisavači zatvoreni (odmor)",
    AVAILABILITY_VACUUMS_STATUS_4: "Usisavači zatvoreni (radno vrijeme)",
    AVAILABILITY_VACUUMS_STATUS_5: "Usisavači zatvoreni (kvar)",
    AVAILABILITY_VACUUMS_STATUS_6: "Usisavači zatvoreni (ostalo)",
    ECOM_AMOUNT: "Ukupni Ecom za sve lokacije",
    CAPTURED: "Zabilježeno",
    DELETE_COMPANY_HISTORY_INFO:"Ova radnja će izbrisati sve podatke izvješća vaše tvrtke. Ova radnja se ne može poništiti.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Jeste li sigurni da želite trajno izbrisati sve podatke izvješća?",
    VALUE_DATE: "Datum valute",
    KARCHER_EVENT_NAME_1: "Osnovni izmjenjivač topline regeneriran",
    KARCHER_EVENT_NAME_2: "Regeneracija osnovnog izmjenjivača dovršena",
    KARCHER_EVENT_NAME_3: "Materijal / serijski broj",
    KARCHER_EVENT_NAME_4: "Sustav je dezinficiran",
    KARCHER_EVENT_NAME_5: "HP pumpa 1 dezinficirana",
    KARCHER_EVENT_NAME_6: "HP pumpa 2 dezinficirana",
    KARCHER_EVENT_NAME_7: "HP pumpa 3 dezinficirana",
    KARCHER_EVENT_NAME_8: "HP pumpa 4 dezinficirana",
    KARCHER_EVENT_NAME_9: "HP pumpa 5 dezinficirana",
    KARCHER_EVENT_NAME_10: "Stanica za pranje 1 zaključana",
    KARCHER_EVENT_NAME_11: "Stanica za pranje 2 zaključana",
    KARCHER_EVENT_NAME_12: "Stanica za pranje 3 zaključana",
    KARCHER_EVENT_NAME_13: "Stanica za pranje 4 zaključana",
    KARCHER_EVENT_NAME_14: "Stanica za pranje 5 zaključana",
    KARCHER_EVENT_NAME_15: "Stanica za pranje 6 zaključana",
    KARCHER_EVENT_NAME_16: "Stanica za pranje 7 zaključana",
    KARCHER_EVENT_NAME_17: "Stanica za pranje 8 zaključana",
    KARCHER_EVENT_NAME_18: "Ažuriranje započeto",
    KARCHER_EVENT_NAME_19: "Ažuriranje dovršeno",
    KARCHER_EVENT_NAME_20: "Početak WS Reg",
    KARCHER_EVENT_NAME_21: "Kraj WS Reg",
    KARCHER_EVENT_NAME_22: "WS senzor 75%",
    KARCHER_EVENT_NAME_23: "Tehnički kvar",
    KARCHER_EVENT_NAME_24: "Operativni kvar",
    KARCHER_EVENT_NAME_25: "Uređaj uključen",
    KARCHER_EVENT_NAME_26: "Uređaj isključen",
    KARCHER_EVENT_NAME_27: "Kutija 1 zatvorena",
    KARCHER_EVENT_NAME_28: "Kutija 2 zatvorena",
    KARCHER_EVENT_NAME_29: "Kutija 3 zatvorena",
    KARCHER_EVENT_NAME_30: "Kutija 4 zatvorena",
    KARCHER_EVENT_NAME_31: "Kutija 5 zatvorena",
    KARCHER_EVENT_NAME_32: "Kutija 6 zatvorena",
    KARCHER_EVENT_NAME_33: "Kutija 7 zatvorena",
    KARCHER_EVENT_NAME_34: "Kutija 8 zatvorena",
    KARCHER_EVENT_NAME_35: "HP pumpna stanica 1",
    KARCHER_EVENT_NAME_36: "HP pumpna stanica 2",
    KARCHER_EVENT_NAME_37: "HP pumpna stanica 3",
    KARCHER_EVENT_NAME_38: "HP pumpna stanica 4",
    KARCHER_EVENT_NAME_39: "HP pumpna stanica 5",
    KARCHER_EVENT_NAME_40: "HP pumpna stanica 6",
    KARCHER_EVENT_NAME_41: "HP pumpna stanica 7",
    KARCHER_EVENT_NAME_42: "HP pumpna stanica 8",
    KARCHER_EVENT_NAME_43: "Plamenik",
    KARCHER_EVENT_NAME_44: "Ventilator plamenika",
    KARCHER_EVENT_NAME_45: "Pumpa za toplu vodu",
    KARCHER_EVENT_NAME_46: "Pumpa za zaštitu od smrzavanja",
    KARCHER_EVENT_NAME_47: "Osmotska pumpa",
    KARCHER_EVENT_NAME_48: "Podno grijanje",
    KARCHER_EVENT_NAME_49: "Grijanje crijeva",
    KARCHER_EVENT_NAME_50: "Mikro/čišćenje felgi",
    KARCHER_EVENT_NAME_51: "Podvozna pumpa",
    KARCHER_EVENT_NAME_52: "Pumpa za pjenu Booster",
    KARCHER_EVENT_NAME_53: "Usisavač 1",
    KARCHER_EVENT_NAME_54: "Usisavač 2",
    KARCHER_EVENT_NAME_55: "Usisavač 3",
    KARCHER_EVENT_NAME_56: "Usisavač 4",
    KARCHER_EVENT_NAME_57: "Usisavač 5",
    KARCHER_EVENT_NAME_58: "Usisavač 6",
    KARCHER_EVENT_NAME_59: "Usisavač 7",
    KARCHER_EVENT_NAME_60: "Usisavač 8",
    KARCHER_EVENT_NAME_61: "Usisavač 9",
    KARCHER_EVENT_NAME_62: "Usisavač 10",
    KARCHER_EVENT_NAME_63: "Usisavač 11",
    KARCHER_EVENT_NAME_64: "Usisavač 12",
    KARCHER_EVENT_NAME_65: "Pumpa za čišćenje felgi",
    KARCHER_EVENT_NAME_66: "Microe pumpa",
    KARCHER_EVENT_NAME_67: "Intenzivna pumpa",
    KARCHER_EVENT_NAME_68: "Turbina usisavača 1",
    KARCHER_EVENT_NAME_69: "Filter usisavača 1",
    KARCHER_EVENT_NAME_70: "Turbina usisavača 2",
    KARCHER_EVENT_NAME_71: "Filter usisavača 2",
    KARCHER_EVENT_NAME_72: "Turbina usisavača 3",
    KARCHER_EVENT_NAME_73: "Filter usisavača 3",
    KARCHER_EVENT_NAME_74: "Turbina usisavača 4",
    KARCHER_EVENT_NAME_75: "Filter usisavača 4",
    KARCHER_EVENT_NAME_76: "Turbina usisavača 5",
    KARCHER_EVENT_NAME_77: "Filter usisavača 5",
    KARCHER_EVENT_NAME_78: "Turbina usisavača 6",
    KARCHER_EVENT_NAME_79: "Filter usisavača 6",
    KARCHER_EVENT_NAME_80: "Turbina usisavača 7",
    KARCHER_EVENT_NAME_81: "Filter usisavača 7",
    KARCHER_EVENT_NAME_82: "Turbina usisavača 8",
    KARCHER_EVENT_NAME_83: "Filter usisavača 8",
    KARCHER_EVENT_NAME_84: "Turbina usisavača 9",
    KARCHER_EVENT_NAME_85: "Filter usisavača 9",
    KARCHER_EVENT_NAME_86: "Turbina usisavača 10",
    KARCHER_EVENT_NAME_87: "Filter usisavača 10",
    KARCHER_EVENT_NAME_88: "Turbina usisavača 11",
    KARCHER_EVENT_NAME_89: "Filter usisavača 11",
    KARCHER_EVENT_NAME_90: "Turbina usisavača 12",
    KARCHER_EVENT_NAME_91: "Filter usisavača 12",
    INSERT_TOKEN: "Unesite tokene i pokrenite uslugu",
    OPEN_SESSION: "Sesija uspješno otvorena",
    IN_PROGRESS: "U tijeku ...",
    TOKEN_INSERTED: "Tokeni su uspješno uneseni",
    EXPIRED_SESSION: "Sesija je istekla",
    TWO_DIGIT_INTEGER_VALIDATION: "Koristite maksimalno dvoznamenkasti cijeli broj",
    KARCHER_OPERATION_COUNTER_1: "Stanica za pranje 1 HP pumpa",
    KARCHER_OPERATION_COUNTER_2: "Stanica za pranje 1 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_3: "Stanica za pranje 1 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_4: "Stanica za pranje 1 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_5: "Stanica za pranje 1 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_6: "Stanica za pranje 2 HP pumpa",
    KARCHER_OPERATION_COUNTER_7: "Stanica za pranje 2 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_8: "Stanica za pranje 2 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_9: "Stanica za pranje 2 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_10: "Stanica za pranje 2 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_11: "Stanica za pranje 3 HP pumpa",
    KARCHER_OPERATION_COUNTER_12: "Stanica za pranje 3 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_13: "Stanica za pranje 3 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_14: "Stanica za pranje 3 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_15: "Stanica za pranje 3 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_16: "Stanica za pranje 4 HP pumpa",
    KARCHER_OPERATION_COUNTER_17: "Stanica za pranje 4 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_18: "Stanica za pranje 4 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_19: "Stanica za pranje 4 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_20: "Stanica za pranje 4 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_21: "Stanica za pranje 5 HP pumpa",
    KARCHER_OPERATION_COUNTER_22: "Stanica za pranje 5 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_23: "Stanica za pranje 5 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_24: "Stanica za pranje 5 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_25: "Stanica za pranje 5 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_26: "Stanica za pranje 6 HP pumpa",
    KARCHER_OPERATION_COUNTER_27: "Stanica za pranje 6 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_28: "Stanica za pranje 6 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_29: "Stanica za pranje 6 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_30: "Stanica za pranje 6 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_31: "Stanica za pranje 7 HP pumpa",
    KARCHER_OPERATION_COUNTER_32: "Stanica za pranje 7 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_33: "Stanica za pranje 7 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_34: "Stanica za pranje 7 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_35: "Stanica za pranje 7 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_36: "Stanica za pranje 8 HP pumpa",
    KARCHER_OPERATION_COUNTER_37: "Stanica za pranje 8 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_38: "Stanica za pranje 8 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_39: "Stanica za pranje 8 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_40: "Stanica za pranje 8 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_41: "Pumpa za osmozu",
    KARCHER_OPERATION_COUNTER_42: "Generator tople vode",
    KARCHER_OPERATION_COUNTER_43: "Pumpa za zaštitu od smrzavanja",
    KARCHER_OPERATION_COUNTER_44: "WSO ulošci filtra",
    KARCHER_OPERATION_COUNTER_45: "Pumpa za grijanje stanice za pranje",
    KARCHER_OPERATION_COUNTER_46: "Pumpa za toplu vodu",
    KARCHER_OPERATION_COUNTER_47: "Grijač crijeva za pjenu",
    KARCHER_OPERATION_COUNTER_48: "Pumpa za pranje kotača",
    KARCHER_OPERATION_COUNTER_49: "Pumpa za mikroemulziju",
    KARCHER_OPERATION_COUNTER_50: "Pumpa za intenzivnu pjenu",
    KARCHER_OPERATION_COUNTER_51: "Usisavač 1 turbina 1",
    KARCHER_OPERATION_COUNTER_52: "Usisavač 1 filtar 1",
    KARCHER_OPERATION_COUNTER_53: "Usisavač 1 turbina 2",
    KARCHER_OPERATION_COUNTER_54: "Usisavač 1 filtar 2",
    KARCHER_OPERATION_COUNTER_55: "Usisavač 2 turbina 1",
    KARCHER_OPERATION_COUNTER_56: "Usisavač 2 filtar 1",
    KARCHER_OPERATION_COUNTER_57: "Usisavač 2 turbina 2",
    KARCHER_OPERATION_COUNTER_58: "Usisavač 2 filtar 2",
    KARCHER_OPERATION_COUNTER_59: "Usisavač 3 turbina 1",
    KARCHER_OPERATION_COUNTER_60: "Usisavač 3 filtar 1",
    KARCHER_OPERATION_COUNTER_61: "Usisavač 3 turbina 2",
    KARCHER_OPERATION_COUNTER_62: "Usisavač 3 filtar 2",
    KARCHER_OPERATION_COUNTER_63: "Usisavač 4 turbina 1",
    KARCHER_OPERATION_COUNTER_64: "Usisavač 4 filtar 1",
    KARCHER_OPERATION_COUNTER_65: "Usisavač 4 turbina 2",
    KARCHER_OPERATION_COUNTER_66: "Usisavač 4 filtar 2",
    KARCHER_OPERATION_COUNTER_67: "Usisavač 5 turbina 1",
    KARCHER_OPERATION_COUNTER_68: "Usisavač 5 filtar 1",
    KARCHER_OPERATION_COUNTER_69: "Usisavač 5 turbina 2",
    KARCHER_OPERATION_COUNTER_70: "Usisavač 5 filtar 2",
    KARCHER_OPERATION_COUNTER_71: "Usisavač 6 turbina 1",
    KARCHER_OPERATION_COUNTER_72: "Usisavač 6 filtar 1",
    KARCHER_OPERATION_COUNTER_73: "Usisavač 6 turbina 2",
    KARCHER_OPERATION_COUNTER_74: "Usisavač 6 filtar 2",
    KARCHER_OPERATION_COUNTER_75: "Ispustite kondenziranu vodu iz kompresora",
    KARCHER_OPERATION_COUNTER_76: "Provjerite sustav zaštite od smrzavanja",
    KARCHER_OPERATION_COUNTER_77: "Ventilator plamenika",
    KARCHER_OPERATION_COUNTER_78: "Pojačana pumpa za pjenu",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Popis podataka je veći od 10000 stavki",
    KARCHER_POINT_NAME_1: "Praznik",
    KARCHER_POINT_NAME_2: "Ponedjeljak",
    KARCHER_POINT_NAME_3: "Utorak",
    KARCHER_POINT_NAME_4: "Srijeda",
    KARCHER_POINT_NAME_5: "Četvrtak",
    KARCHER_POINT_NAME_6: "Petak",
    KARCHER_POINT_NAME_7: "Subota",
    KARCHER_POINT_NAME_8: "Nedjelja",
    KARCHER_POINT_NAME_9: "Usisavači Praznik",
    KARCHER_POINT_NAME_10: "Usisavači Ponedjeljak",
    KARCHER_POINT_NAME_11: "Usisavači Utorak",
    KARCHER_POINT_NAME_12: "Usisavači Srijeda",
    KARCHER_POINT_NAME_13: "Usisavači Četvrtak",
    KARCHER_POINT_NAME_14: "Usisavači Petak",
    KARCHER_POINT_NAME_15: "Usisavači Subota",
    KARCHER_POINT_NAME_16: "Usisavači Nedjelja",
    KARCHER_POINT_NAME_17: "Rasvjeta Praznik",
    KARCHER_POINT_NAME_18: "Rasvjeta Ponedjeljak",
    KARCHER_POINT_NAME_19: "Rasvjeta Utorak",
    KARCHER_POINT_NAME_20: "Rasvjeta Srijeda",
    KARCHER_POINT_NAME_21: "Rasvjeta Četvrtak",
    KARCHER_POINT_NAME_22: "Rasvjeta Petak",
    KARCHER_POINT_NAME_23: "Rasvjeta Subota",
    KARCHER_POINT_NAME_24: "Rasvjeta Nedjelja",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "QR kod",
    ACCEPT_TERMS_AND_CONDITIONS: "Prihvati uvjete korištenja",
    CREATE_AND_PRINT_VOUCHERS: "Kreiraj i printaj vaučere",
    CREATE_AND_PRINT_VOUCHERS_VACC: "Kreiraj i printaj vaučere - VACC",
    CREATE_AND_PRINT_VOUCHERS_JET_WASH: "Kreiraj i printaj vaučere - JET WASH",
    CODE_PREFIX_QUESTION: "Prefiks kod nije unesen",
    CODE_PREFIX_QUESTION_TEXT: "Želite li nastaviti bez prefiks koda?",
    ISSUED_DATE: "Datum izdavanja",
    VOUCHER_VALIDITY_DAYS: "Rok važenja vaučera (dani)",
    VALIDATION_ONLY_NUMBERS: "Dozvoljen je unos samo brojeva",
    REPRINT_VOUCHERS: "Printaj kopiju vaučera",
    EXPIRY_DATE: "Vrijedi do",
    ROLLOVER_SALES_TYPES: "Tipovi prodaje",
    ROLLOVER_SALES_TYPE_ACTIVE: "Aktivan",
    ROLLOVER_SALES_TYPE_UPDATED: "Tip prodaje uspješno ažuriran",
    ROLLOVER_NO_SALES_TYPES: "Nema dostupnih tipova prodaje",
    ROLLOVER_ZERO_PRICE: "Nulta cijena",
    ROLLOVER_SPECIAL_OFFER_PRICES: "Cijene specijalne ponude",
    ROLLOVER_UNLIMITED_WASHES: "Neograničena pranja",
    ACTIVE: "Aktivan",
    INACTIVE: "Neaktivan",
    SUCCESS: "Uspjeh",
    ASIDE_MENU_SAVINGS: "Štednja",
    SAVINGS_SEARCH_PLACEHOLDER: "Pretraži po ID korisnika ili kompaniji",
    SAVINGS_USERS_LIST: "Korisnici štednje",
    SAVINGS_NO_USERS: "Nema pronađenih korisnika štednje",
    SAVINGS_USER_ID: "ID korisnika",
    SAVINGS_COMPANY: "Kompanija",
    SAVINGS_BALANCE: "Stanje",
    SAVINGS_INITIAL_CREDIT: "Početni kredit",
    SAVINGS_REMAINING_CREDIT: "Preostali kredit",
    SAVINGS_CREATED_DATE: "Datum kreiranja",
    SAVINGS_STATUS: "Status",
    SAVINGS_EXPIRATION_DATE: "Datum isteka",
    SAVINGS_POSTPAID: "Postpaid",
    SAVINGS_ACTIONS: "Akcije",
    SAVINGS_DEACTIVATE: "Deaktiviraj",
    SAVINGS_DEACTIVATE_TITLE: "Deaktiviraj štedni račun",
    SAVINGS_DEACTIVATE_MESSAGE: "Jeste li sigurni da želite deaktivirati ovaj štedni račun?",
    SAVINGS_PACKAGES: "Štedni paketi",
    SAVINGS_CREDIT_AMOUNT: "Iznos kredita",
    SAVINGS_EXPIRATION_DAYS: "Dani valjanosti štednje",
    SAVINGS_EXPIRATION_DAYS_UPDATED: "Dani valjanosti štednje uspješno ažurirani",
    IDENTIFICATION_CODE: "Identifikacijski kôd",
    SAVINGS_CREATE_TITLE: "Kreiraj novog korisnika",
    SAVINGS_SALE_TYPE: "Tip prodaje",
    SAVINGS_SALE_TYPE_REGULAR: "Regularno",
    SAVINGS_SALE_TYPE_POSTPAID: "Postpaid",
    SAVINGS_SALE_TYPE_PACKAGE: "Paket",
    SAVINGS_SELECT_PACKAGE: "Odaberi paket",
    SAVINGS_PACKAGE: "Paket",
    SAVINGS_AMOUNT: "Iznos",
    SAVINGS_VALIDITY_PERIOD: "Period valjanosti",
    SAVINGS_VALID_FROM: "Vrijedi od",
    SAVINGS_VALID_TO: "Vrijedi do",
    SAVINGS_VALIDITY_DAYS: "Dani valjanosti",
    SAVINGS_SUMMARY: "Sažetak",
    SAVINGS_CREATE_AND_PRINT: "Kreiraj i ispiši",
    SAVINGS_CREATING: "Kreiranje...",
    SAVINGS_EDIT_TITLE: "Uredi korisnika štednje",
    SAVINGS_USER_INFO: "Informacije o korisniku",
    SAVINGS_CURRENT_CREDIT: "Trenutni kredit",
    SAVINGS_NEW_CREDIT: "Novi kredit",
    SAVINGS_LOAD_ERROR: "Greška pri učitavanju računa štednje",
    SAVINGS_EDIT_SUCCESS: "Račun štednje uspješno ažuriran",
    SAVINGS_EDIT_ERROR: "Greška pri ažuriranju računa štednje",
    VOUCHER_TYPE_VACUUM: "Vaučer za: Usisavač",
    VOUCHER_TYPE_JETWASH: "Vaučer za: Jet Wash Care",
    VOUCHER_TYPE_MATT: "Vaučer za: Matt",
    SAVINGS_TAB_REPORTS: "Izvještaji",
    SAVINGS_REPORTS_TITLE: "Izvještaji štednje",
    SAVINGS_REPORTS_NOTE: "Napomena: Štednja isključuje Happy Hour (bez duplih popusta)",
    SAVINGS_REPORTS_SELECT_PERIOD: "Odaberite period i kliknite Pretraži",
    SAVINGS_REPORT_REVENUE_BY_SALES_TYPE: "Prihod po tipu prodaje",
    SAVINGS_REPORT_ISSUED_CREDIT_BY_SALES_TYPE: "Izdani kredit po tipu prodaje",
    SAVINGS_REPORT_REDEEMED_BY_DEVICE_TYPE: "Iskorištena štednja po tipu uređaja",
    SAVINGS_SALES_TYPE: "Tip prodaje",
    SAVINGS_DEVICE_TYPE: "Tip uređaja",
    DEVICE_TYPE_SEMPRA_BRIDGE: "Sempra Bridge",
    DEVICE_TYPE_SERIAL_485: "Serial 485",
    DEVICE_TYPE_CHANGER: "Mjenjačnica",
    DEVICE_TYPE_BRIDGE_WITH_LISTENER: "Bridge s Listenerom",
    DEVICE_TYPE_KARCHER: "Kärcher",
    DEVICE_TYPE_HHANLE: "Hermann Hänle",
    DEVICE_TYPE_SB_OB: "SB OB",
    DEVICE_TYPE_SB_MU_MB: "SB MU MB",
    DEVICE_TYPE_CW1: "CW1",
    DEVICE_TYPE_CW3: "CW3",
    DEVICE_TYPE_CW35: "CW35",
    DEVICE_TYPE_CB3: "CB3",
    DEVICE_TYPE_ST_JETWASH: "Jetwash",
    DEVICE_TYPE_ST_ROLLOVER: "Rollover",
    DEVICE_TYPE_ADYEN_BRIDGE: "Adyen Bridge",
    DEVICE_TYPE_POS2VP: "POS2VP",
    DEVICE_TYPE_POS2PLC: "POS2PLC",
    DEVICE_TYPE_POS2IMPULS: "POS2IMPULS",
    DEVICE_TYPE_ROLLOVER_BRIDGE: "Rollover Bridge",
    DEVICE_TYPE_ALTA_PRO: "Alta Pro",
    DEVICE_TYPE_UNKNOWN: "Nepoznato"
  });
})();
